// 中央配置ボタン
import React from 'react';
import { Button } from 'react-bootstrap';
var CenterButton = function (_a) {
    var label = _a.label, handleClick = _a.handleClick;
    return (React.createElement("div", { className: "center-button" },
        React.createElement(Button
        // ボタンのクリック設定
        , { 
            // ボタンのクリック設定
            onClick: handleClick, className: "col-xs-6 col-sm-4 col-md-2 col-4", size: "lg", variant: "custom" }, label)));
};
export default CenterButton;
